import React from "react";
import { useMarketingCopy } from "./MarketingShell";
import narrative from "./siteNarrativeCopy.json";
import "./GrowthPitch.css";

function GrowthCurve() {
  return <svg className="growth-curve" viewBox="0 0 560 260" aria-hidden="true">
    <path className="growth-grid" d="M30 220H540M30 158H540M30 96H540" />
    <path className="growth-baseline" d="M30 213C150 207 290 191 535 169" />
    <path className="growth-acceleration" d="M30 213C160 207 262 200 334 177S455 103 535 29" />
    <circle cx="334" cy="177" r="5" className="growth-pivot" />
  </svg>;
}

export default function GrowthPitch() {
  const { language } = useMarketingCopy();
  const { problem, solution, pilot } = (narrative[language] ?? narrative.en).home.pitch;
  return <div className="growth-pitch">
    <section className="quant-wrap growth-problem" aria-labelledby="growth-problem-title">
      <div><p className="narrative-label">{problem.label}</p><h2 id="growth-problem-title">{problem.title}</h2><p className="growth-body">{problem.description}</p></div>
      <ul className="growth-lanes">{problem.lanes.map(lane => <li key={lane}>{lane}</li>)}</ul>
    </section>
    <section className="quant-wrap growth-solution" aria-labelledby="growth-solution-title">
      <div className="growth-solution-intro"><div><p className="narrative-label">{solution.label}</p><h2 id="growth-solution-title">{solution.title}</h2><p className="growth-body">{solution.description}</p></div><figure><GrowthCurve /><figcaption>{solution.curve}</figcaption></figure></div>
      <ul className="growth-areas">{solution.areas.map(area => <li key={area.title}><h3>{area.title}</h3><p>{area.detail}</p></li>)}</ul>
    </section>
    <section className="quant-wrap growth-pilot" aria-labelledby="growth-pilot-title">
      <div className="growth-pilot-heading"><p className="narrative-label">{pilot.label}</p><h2 id="growth-pilot-title">{pilot.title}</h2><p className="growth-body">{pilot.description}</p></div>
      <ol>{pilot.steps.map((step,index) => <li key={step.title}><span aria-hidden="true">{String(index + 1).padStart(2,"0")}</span><h3>{step.title}</h3><p>{step.detail}</p></li>)}</ol>
      <a className="growth-how-link" href="#capabilities">{pilot.close}</a>
    </section>
  </div>;
}
